import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less']
})
export class ButtonComponent implements OnInit {

  @Input() isLoading = false;
  @Input() label = '';
  @Input() isFullWidth = false;
  @Input() innerTextClasses = 'text-base';
  @Input() spinnerClasses = 'my-3';
  @Input() isActive = false;

  @Output() click = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  onClick() {
    if (!this.isLoading)
      this.click.emit();
  }

}
